import { createEntityListPage } from "./createEntityListPage";
import {
  useCategories,
  useAddCategory,
  useUpdateCategory,
} from "../../api/lists";

export const CategoriesPage = createEntityListPage({
  title: "Categories",
  entityType: "category",
  useList: useCategories,
  useAdd: useAddCategory,
  useUpdate: useUpdateCategory,
});
